import {useEffect} from "react";

type Meta = { name?: string; property?: string; content: string };
type Link = { rel: string; href: string };
type Script = { type?: string; jsonLD?: unknown; text?: string };

export function useHead(opts: {
    title?: string;
    metas?: Meta[];
    links?: Link[];
    scripts?: Script[];
}) {
    useEffect(() => {
        const created: HTMLElement[] = [];

        // title
        const prevTitle = document.title;
        if (opts.title) document.title = opts.title;

        // meta
        (opts.metas ?? []).forEach(m => {
            const el = document.createElement("meta");
            if (m.name) el.setAttribute("name", m.name);
            if (m.property) el.setAttribute("property", m.property);
            el.setAttribute("content", m.content);
            document.head.appendChild(el);
            created.push(el);
        });

        // link (canonical и т.п.)
        (opts.links ?? []).forEach(l => {
            const el = document.createElement("link");
            el.setAttribute("rel", l.rel);
            el.setAttribute("href", l.href);
            document.head.appendChild(el);
            created.push(el);
        });

        // scripts (JSON‑LD и др.)
        (opts.scripts ?? []).forEach(s => {
            const el = document.createElement("script");
            el.type = s.type ?? "application/ld+json";
            if (s.jsonLD) el.textContent = JSON.stringify(s.jsonLD);
            if (s.text) el.text = s.text;
            document.head.appendChild(el);
            created.push(el);
        });

        // cleanup
        return () => {
            created.forEach(el => el.remove());
            if (opts.title) document.title = prevTitle;
        };
    }, [opts.title, JSON.stringify(opts.metas), JSON.stringify(opts.links), JSON.stringify(opts.scripts)]);
}